import {z as zod} from "zod";

export type OttosyncDataSourcesWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottosyncDataSourcesWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttosyncDataSourcesWorkspaceCapabilityConfiguration> = zod.strictObject({});
